export const heroData = {
  heroTitle: null,
  heroSubText: null,
  parallax: true,
  heroImage: {
    desktopUrl:
      "https://frontend-assets.buildbox.com/Buildbox3_DesktopHero_New3.jpg",
    mobileUrl: "https://frontend-assets.buildbox.com/BB3HeroMobile.jpg",
    lowResDesktopImageUrl:
      "https://frontend-assets.buildbox.com/Buildbox3_DesktopHero_New.jpg",
  },
  showHeadrest: true,
  hasButton: true,
  heroButton: {
    buttonText: "Download Now",
    buttonLink: "/downloads/bb3",
    isLinkExternal: false,
    linkedToDownloads: true,
    borderColor: "#fff",
    backgroundColor: "transparent",
    hoverStyle: {
      borderColor: "white",
      buttonColor: "white",
      textColor: "#F16522",
    },
  },
  unfoldFuton: true,
  futonData: {
    futonLogo: "https://frontend-assets.buildbox.com/BB3+logo.svg",
    title: `The Ultimate ${"\n"} 3D Game Builder`,
    subtext:
      "Buildbox 3 allows anyone to design, build, and publish amazing 3D and 2D games. Choose how you want to build out your game!",
    backgroundColor: "#0c8bb4",
  },
  product: "BB3",
};

export const bbShopObj = {
  product: "BB3",
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Buildbox Shop",
  description:
    "The Buildbox Shop is our asset store with tons of free and premium assets at your fingertips! Constantly updated, you'll find everything you need to complete your game, from 2D and 3D assets to UI elements.\n",
  description2: "Interested in selling your original assets to other creators for use in their games? Click the link below and start selling your assets today!",
  hasButton: false,
  hasLogo: true,
  buttonLabel: "Get Started",
  imgStart: true,
  img: "https://frontend-assets.buildbox.com/templates_V3 2.png",
  alt: "Buildbox 3 Template Library",
  start: "",
  // backgroundImg:
  //   "https://frontend-assets.buildbox.com/product_feature_1_bg.svg",
  logoSrc: "https://frontend-assets.buildbox.com/2022_BB3_BC_BBShop_Logo_Cart_Outline.svg",
  descriptionButtonLink:"https://shop.buildbox.com",
  descriptionButtonSrc:"https://frontend-assets.buildbox.com/2022_BB3_BC_BBShop_BB3Page_Button.svg"
};

export const homeObjOne = {
  product: "BB3",
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Template Library",
  description:
    "To help you get started and save time, use the built-in Template Library. Each template is a mini-game with prebuilt functionality you can edit and customize. Make stunning 3D space shooters, challenging racers, epic adventures, and more.",
  hasButton: false,
  hasLogo: true,
  buttonLabel: "Get Started",
  imgStart: "",
  img: "https://frontend-assets.buildbox.com/template_library_opt_V2+2.png",
  alt: "Buildbox 3 Template Library",
  start: "",
  backgroundImg:
    "https://frontend-assets.buildbox.com/product_feature_1_bg.svg",
  logoSrc: "https://frontend-assets.buildbox.com/BB3_TemplateLibrary.svg",
};

export const homeObjTwo = {
  product: "BB3",
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Smart Assets™",
  description:
    "There’s also a built-in Asset Library with Smart Assets™ to help you bring your game to life. Each asset comes with preset animations and logic, speeding up game development and ease-of-use. Plus, you can edit them down to their node structure or code.",
  hasButton: false,
  hasLogo: true,
  buttonLabel: "Get Started",
  imgStart: "start",
  img: "https://frontend-assets.buildbox.com/smart_assets_opt.png",
  alt: "Buildbox 3 Smart Assets™",
  start: "",
  backgroundImg:
    "https://frontend-assets.buildbox.com/product_feature_2_bg.svg",
  logoSrc: "https://frontend-assets.buildbox.com/BB3_SmartAssets.svg",
};

export const homeObjThree = {
  product: "BB3",
  lightBg: false,
  lightTopLine: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Brainboxes™",
  description:
    "Buildbox 3 also features Brainboxes™. With them, you can make any character or object in your game move. These drag-and-drop animation components feature built-in logic that makes it easy to create.",
  hasButton: false,
  hasLogo: true,
  buttonLabel: "",
  imgStart: "",
  img: "https://frontend-assets.buildbox.com/brainboxes_opt.png",
  alt: "Buildbox 3 Brainboxes™",
  start: "true",
  backgroundImg:
    "https://frontend-assets.buildbox.com/product_feature_3_bg.svg",
  logoSrc: "https://frontend-assets.buildbox.com/brainbox_icon_V2.svg",
};

export const homeObjFour = {
  product: "BB3",
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Adbox Monetization",
  description:
    "Earning ad revenue from your game is now as easy as 1, 2, 3! Simply integrate Adbox into your game, publish to Google Play or the App Store, and get paid! Adbox handles the rest, from ad optimization (ensuring you the most ad revenue) to payouts, Adbox has you covered.",
  hasButton: false,
  hasLogo: true,
  buttonLabel: "Get Started",
  imgStart: "start",
  img: "https://frontend-assets.buildbox.com/ez_opt.png",
  alt: "Adbox Monetization",
  start: "",
  backgroundImg:
    "https://frontend-assets.buildbox.com/product_feature_4_bg.svg",
  logoSrc: "https://frontend-assets.buildbox.com/Group.svg",
};

export const homeObjFive = {
  backgroundImg: "shapesBg",
  product: "BB3",
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: null,
  headline: "",
  description: "",
  buttonLabel: "Sign Up Now",
  imgStart: "start",
  img: "https://www.w3schools.com/tags/pic_trulli.jpg",
  alt: "Vault",
  start: "true",
  isCarousel: true,
  cardItems: [
    {
      title: "Tutorials",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/BB3_Tutorial_opt.jpg",
      imgLink: "https://www.buildbox.com/tutorials-buildbox-3/",
      description:
        "We have tutorials, manuals, and personal email support for any customer who needs it.",
      alt: "Buildbox Tutorials",
      button: true,
      buttonCTA: "Learn More",
    },
    {
      title: "Community",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/Community_image_opt.jpg",
      imgLink: "https://www.buildbox.com/forum/index.php",
      description: "Join our active forums to learn how to use Buildbox.",
      alt: "Buildbox Community",
      button: true,
      buttonCTA: "Learn More",
    },
  ],
};

export const homeObjSix = {
  product: "BB3",
  topLine: "Is Buildbox 3 \n right for you?",
  lightTopLine: true,
  lightBg: false,
  hasButton: true,
  subtitle:
    "Use no-code options like Smart Assets™ and Brainboxes™ to bring your 3D models to life in Buildbox 3.",
  buttonLabel: "Download Free",
  ctaLink: "/downloads/bb3",
  listItems: [
    {
      title: "3D \n Games",
      lightText: true,
      img: null,
      imgLink: "",
      description:
        "If you want to create advanced 3D games, Buildbox 3 is for you. With full FBX support, you can add 3D models, objects, and more.",
      alt: "3D Games",
    },
    {
      title: "Full \n Customization",
      lightText: true,
      img: null,
      imgLink: "",
      description:
        "If you have some experience making games, Buildbox 3 allows you to edit or create your own smart nodes to fully customize.",
      alt: "Full Customization",
    },
    {
      title: "Fast \n Prototyping",
      lightText: true,
      img: null,
      imgLink: "",
      description:
        "If you want lightning-fast prototyping for both 3D and 2D games, you can switch from 3D and 2D game creation with a quick click.",
      alt: "Fast Prototyping",
    },
  ],
};

export const homeObjSeven = {
  product: "gamesBg",
  topLine: "Amazing Games \n  Made Here",
  lightTopLine: true,
  lightBg: false,
  hoverStyle: true,
  listItems: [
    {
      title: "",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/railwaycanyon.png",
      imgLink: "/games",
      descTitle: "Railway Canyon",
      description:
        "Railway Canyon by Crevasse Studios is a Wild West 3D puzzler.",
      alt: "Railway Canyon",
      button: true,
      buttonCTA: "Learn More",
      link: "https://www.buildbox.com/buildbox-game-spotlight-railway-canyon/",
    },
    {
      title: "",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/cyberdrive.png",
      imgLink: "/games",
      descTitle: "Cyber Drive",
      description:
        "Cyber Drive by Tap Men Games is a 3D futuristic action arcade game.",
      alt: "Cyber Drive",
      button: true,
      buttonCTA: "Learn More",
      link: "https://www.buildbox.com/buildbox-game-spotlight-cyber-drive/",
    },
    {
      title: "",
      lightText: true,
      img: "https://frontend-assets.buildbox.com/shreddedstreets.png",
      imgLink: "/games",
      descTitle: "Shredded Streets",
      description:
        "Shredded Streets by AstroHound Studios is a 3D skateboarding game.",
      alt: "Shredded Streets",
      button: true,
      buttonCTA: "Learn More",
      link:
        "https://www.buildbox.com/buildbox-game-spotlight-shredded-streets/",
    },
  ],
};

export const homeObjEight = {
  product: "",
  parallax: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  textAlign: "left",
  topLine: "",
  headlineImage: true,
  headline:
    "https://frontend-assets.buildbox.com/BBWorld_Logo_horizontal_white.png",
  description:
    "Buildbox World is our brand new mobile app that will change the way you create forever. In seconds, you can export your Buildbox projects straight to your mobile device. Easily test, review, and make adjustments all without relying on third-party applications. Get a true sense of the experience by previewing and playing them right on your phone. Now available on iOS and Android!",
  hasButton: false,
  hasLogo: false,
  buttonLabel: "",
  imgStart: "",
  img: "",
  backgroundImg:
    "https://frontend-assets.buildbox.com/BB3_PG_BBWorld_BG_desktop.jpg",
  alt: "Buildbox World",
  start: "",
  wrapperCustomStyle: {
    padding: "200px",
  },
  headlineImageStyle: {
    width: "362px",
  },
  customClass: "bbworldInfoSection",
};

export const homeObjEightMobile = {
  heroTitle:
    "https://frontend-assets.buildbox.com/BBWorld_Logo_horizontal_white.png",
  heroSubText:
  "Buildbox World is our brand new mobile app that will change the way you create forever. In seconds, you can export your Buildbox projects straight to your mobile device. Easily test, review, and make adjustments all without relying on third-party applications. Get a true sense of the experience by previewing and playing them right on your phone. Now available on iOS and Android!",
  headlineImage: true,
  imageText: "Buildbox World",
  heroImage: {
    desktopUrl:
      "https://frontend-assets.buildbox.com/BB3_PG_BBWorld_image_mobile.png",
    mobileUrl:
      "https://frontend-assets.buildbox.com/BB3_PG_BBWorld_image_mobile.png",
  },
  alignItems: "left",
};


export const footerData = {
  heroTitle: null,
  heroSubText: null,
  heroImage: {
    desktopUrl: "",
    mobileUrl: "",
  },
  showHeadrest: false,
  hasButton: true,
  heroButton: {
    buttonText: "Get Started",
    buttonLink: "/plans/bb3",
    isLinkExternal: false,
    borderColor: "#F16522",
    buttonColor: "#F16522",
    textColor: "white",
    hoverStyle: {
      borderColor: "#D34D0D",
      buttonColor: "#D34D0D",
      textColor: "#FFFFFF",
    },
  },
  unfoldFuton: true,
  futonData: {
    futonLogo: null,
    title: "Start Building Amazing 3D Games Today!",
    subtext: "",
    backgroundColor: "#0c8bb4",
    backgroundImg: "",
  },
  footerStyle: true,
  product: "finalCtaBg",
};
